import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useTranslate from '../../Hooks/useTranslate';
import { CenteredColumnFlexBox } from '../FlexBox';

/**
 * MobilePlaceholder — neutral empty/under-construction state used by mobile
 * screens whose data wiring is not built yet. See MOBILE_PLAN.md §F.
 */
const MobilePlaceholder = function MobilePlaceholder({
  icon = null,
  title = '',
  subtitleKey = 'MOBILE_SECTION_WIP',
}) {
  const theme = useTheme();
  const translate = useTranslate();
  return (
    <CenteredColumnFlexBox
      sx={{
        minHeight: '55vh',
        gap: 1,
        p: 4,
        color: theme.custom.mobile.mutedColor,
        textAlign: 'center',
      }}
    >
      {icon}
      {title ? (
        <Typography
          sx={{ fontSize: 18, fontWeight: 600, color: 'text.primary' }}
        >
          {title}
        </Typography>
      ) : null}
      <Typography variant="body2">{translate(subtitleKey)}</Typography>
    </CenteredColumnFlexBox>
  );
};

export default MobilePlaceholder;
